// Reuses the shimmer rows of the chat list skeleton so both panels load alike.
import skeletonStyles from "components/ChatHistory/components/ThreadListSkeleton.module.scss";

export default function FileListSkeleton() {
  return (
    <div data-skeleton role="status" aria-label="Loading files">
      {Array.from({ length: 8 }, (_, index) => (
        <div key={index} className={skeletonStyles.row}>
          <span
            className={skeletonStyles.text}
            // Gives each row a different width to mimic varying filenames.
            style={{ width: `${50 + ((index * 17) % 40)}%` }}
          />
          <span className={skeletonStyles.dots} />
        </div>
      ))}
    </div>
  );
}
